import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useSimplifiedHeaderExperiment = () => {
    const hasHighContrastBackgroundTreatmentA = useAmplitudeExperimentBase(
        AmplitudeExperiments.SimplifiedHeader,
        AmplitudeVariants.SimplifiedHeader.HighContrastBackground
    );

    const hasSearchBarWithBorderTreatmentB = useAmplitudeExperimentBase(
        AmplitudeExperiments.SimplifiedHeader,
        AmplitudeVariants.SimplifiedHeader.SearchBarWithBorder
    );

    return {
        hasHighContrastBackgroundTreatmentA,
        hasSearchBarWithBorderTreatmentB,
    };
};
